import { render, staticRenderFns } from "./LogEnvioCobranca.vue?vue&type=template&id=661bc2f2"
import script from "./LogEnvioCobranca.vue?vue&type=script&lang=js"
export * from "./LogEnvioCobranca.vue?vue&type=script&lang=js"
import style0 from "./LogEnvioCobranca.vue?vue&type=style&index=0&id=661bc2f2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports